<app-base-dialog
  [visible]="visible()"
  (visibleChange)="close()"
  [title]="('userManagement.invitationTemplate.dialog.title' | transloco) + ' - ' + userRole"
  testId="user-invitation-template-dialog"
  [dismissableMask]="false"
  cancelLabel="common.close"
>
  <div class="mb-4" [attr.data-testid]="'user-invitation-template-dialog-content'">
    <!-- visibility = important for editor-toolbar connection! -->
    @if (visible()) {
      @for (key of [editorKey()]; track key) {
        <app-rich-text-editor
          [key]="editorKey()"
          [initialContent]="initialContent"
          [showSaveButton]="true"
          (saveContent)="saveEditorContent($event)"
        />
      }
    }
  </div>
</app-base-dialog>
